import { PaymentPlanDto } from '@src/data/types/PaymentPlanDto'

export function transformPaymentPlanFromApi(dto: PaymentPlanDto): PaymentPlanDto {
  return {
    ...dto,
    activeFrom: new Date(dto.activeFrom),
    expiresOn: dto.expiresOn ? new Date(dto.expiresOn) : null,
  }
}
